import { createEventHook } from "@vueuse/core"

export interface SiteNotifyEventArgs {
    message: string
    timeout?: number
    actionText?: string
    onAction?: () => void
}

export const siteNotifyEvent = createEventHook<SiteNotifyEventArgs>()
